var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "width": "400",
      "title": "新增客户"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "公司名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入名字..."
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "简称",
      "prop": "abbr"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入简称..."
    },
    model: {
      value: _vm.formItem.abbr,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "abbr", $$v);
      },
      expression: "formItem.abbr"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "可见部门",
      "prop": "department"
    }
  }, [_c('Tree', {
    ref: "createDepartTree",
    attrs: {
      "data": _vm.treeDepartmentData,
      "show-checkbox": "",
      "multiple:": "",
      "false": ""
    },
    on: {
      "on-check-change": _vm.selectDepartment
    }
  }), _vm.getDepartmentByType('sales').length === 0 ? _c('Alert', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("注意：该公司暂时还没有创建销售部门，请前往“用户和权限”菜单新建部门，只有勾选了“销售”的部门才会这里出现")]) : _vm._e()], 1), _c('FormItem', {
    attrs: {
      "label": "可见人",
      "prop": "user"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.formItem.user,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "user", $$v);
      },
      expression: "formItem.user"
    }
  }, _vm._l(_vm.userList.filter(function (x) {
    return !x.superAdmin;
  }), function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "纳入销售统计"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: _vm.formItem.includeInStat.SO,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.includeInStat, "SO", $$v);
      },
      expression: "formItem.includeInStat.SO"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }